import { useContext } from 'react';
import * as R from 'ramda';

import { Stepper } from '@atom/mui';

import CreateWorkModalContext, { ModalStep } from './CreateWorkModalContext';

import classes from './createWorkModal.module.css';

const { StepLabel, Step } = Stepper;

const StepperSidebar = () => {
  const { activeStep, STEPS_ARRAY, draft } = useContext(CreateWorkModalContext);

  const activeStepIndex = R.findIndex(R.propEq(activeStep, 'value'))(
    STEPS_ARRAY,
  );

  const hasTemplateOrScratch =
    !!draft.workTemplate || !!draft.startedFromScratch;

  const getStepSubtext = (step: ModalStep): string => {
    switch (step) {
      case ModalStep.TEMPLATE:
        if (draft.workTemplate?.name) {
          return draft.workTemplate.name;
        }
        return draft.startedFromScratch ? 'Without Template' : '';
      case ModalStep.TASKS: {
        if (!hasTemplateOrScratch) {
          return '';
        }
        const count = draft.tasks?.length || 0;
        return `${count} Added`;
      }
      default:
        return '';
    }
  };

  return (
    <div className={classes.stepperContainer}>
      <Stepper activeStep={activeStepIndex} orientation="vertical">
        {STEPS_ARRAY.map(step => {
          const subtext = getStepSubtext(step.value);

          return (
            <Step key={step.title}>
              <StepLabel>
                <>
                  <div>{step.title}</div>
                  {subtext && (
                    <div className={classes.stepSubtext}>{subtext}</div>
                  )}
                </>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default StepperSidebar;
